import React, { useState, useMemo } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { classes } from '~utils/ClassNames';

import { ContentSpacing } from '@estee/elc-base-theme';
import {
    useReplenishment,
    REPLENISHMENT_BUY_ONCE
} from '~api/ReplenismentAPI/hooks/ReplenishmentHook';

import { ReplenishmentSubscribe } from './ReplenishmentSubscribe/ReplenishmentSubscribe';
import { ReplenishmentDisclaimer } from './ReplenishmentDisclaimer/ReplenishmentDisclaimer';
import { ReplenishmentDropdown } from './ReplenishmentDropdown/ReplenishmentDropdown';

import { IReplenishmentModule } from './IReplenishmentComponent';
import ReplenishmentViewController from './ReplenishmentViewController';

const ReplenishmentWrapper = styled.div`
    display: flex;
    padding: ${ContentSpacing.space8} 0;
    flex-direction: column;
    grid-column: 1 / -1;
    gap: ${ContentSpacing.space8};
`;

const replenishmentModuleWrapperClass = classes('cart-auto-replenishment-container');

export const ReplenishmentModule = observer(({ cartItem }: IReplenishmentModule) => {
    const [controller] = useState(new ReplenishmentViewController());

    const optionsWithoutBuyOnceValue = useMemo(
        () =>
            cartItem.replenishmentOptions.filter(
                ({ value }) => value.toString() !== REPLENISHMENT_BUY_ONCE
            ),
        [cartItem.replenishmentOptions]
    );

    const {
        isLoading,
        selectedValue,
        subscribe,
        onSubscribeChange,
        setSelected
    } = useReplenishment(controller, cartItem);

    return (
        <ReplenishmentWrapper className={replenishmentModuleWrapperClass}>
            <ReplenishmentSubscribe
                setSubscribe={onSubscribeChange}
                isChecked={subscribe}
                isDisabled={isLoading}
            />
            {subscribe && (
                <>
                    <ReplenishmentDropdown
                        replenishmentOptions={optionsWithoutBuyOnceValue}
                        selectedValue={selectedValue}
                        setSelected={setSelected}
                        isLoading={isLoading}
                    />
                    <ReplenishmentDisclaimer />
                </>
            )}
        </ReplenishmentWrapper>
    );
});
